import React, { useMemo } from "react";
import Styles from "./styles.module.scss";
import { useTranslation } from "react-i18next";
import {useDispatch, useSelector} from "react-redux";

import icon1 from '../../../theme/assets/svg/b_cabinet_profile_icon1.svg';
import icon2 from '../../../theme/assets/svg/b_cabinet_profile_icon2.svg';
import icon3 from '../../../theme/assets/svg/b_cabinet_profile_icon3.svg';
import icon4 from '../../../theme/assets/svg/b_cabinet_profile_icon4.svg';

import {setCabinetProfilePersonalInformationEditModalStatus} from "../../../store/cabinet/action";

const EmptyValue = "—";

const CabinetProfilePersonalInformation = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const profileMainData = useSelector(store => store.cabinet.profileMainData);

    const infoItems = useMemo(() => {
        return [
            {
                id: "first_name",
                label: t("Имя"),
                value: profileMainData?.first_name || profileMainData?.firstName || EmptyValue,
                icon: icon1,
            },
            {
                id: "last_name",
                label: t("Фамилия"),
                value: profileMainData?.last_name || profileMainData?.lastName || EmptyValue,
                icon: icon1,
            },
            {
                id: "email",
                label: t("Email"),
                value: profileMainData?.email || EmptyValue,
                icon: icon2,
            },
            {
                id: "phone",
                label: t("Номер телефона"),
                value: profileMainData?.phone || EmptyValue,
                icon: icon3,
            },
            {
                id: "country",
                label: t("Страна"),
                value: profileMainData?.country || EmptyValue,
                icon: icon4,
            },
        ];
    }, [t, profileMainData]);

    const editHandler = () => {
        dispatch(setCabinetProfilePersonalInformationEditModalStatus(true));
    };

    return (
        <div className={Styles.container}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetCard}`}>
                <div className={Styles.titleRow}>
                    <div className={Styles.title}>
                        {t("Личная информация")}
                    </div>

                    <button
                        type="button"
                        className={Styles.editBtn}
                        onClick={editHandler}
                    >
                        {t("Редактировать")}
                    </button>
                </div>

                <div className={Styles.infoList}>
                    {infoItems.map((item) => (
                        <div
                            className={Styles.infoRow}
                            key={item.id}
                        >
                            <div className={Styles.infoIcon}>
                                <img src={item.icon} alt={item.label}/>
                            </div>

                            <div className={Styles.infoLabel}>
                                {item.label}
                            </div>

                            <div
                                className={`
                                    ${Styles.infoValue}
                                    ${item.value === EmptyValue ? Styles.infoValueEmpty : ""}
                                `}
                            >
                                {item.value}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default CabinetProfilePersonalInformation;